import { render, staticRenderFns } from "./Corporation.vue?vue&type=template&id=a009ca04"
import script from "./Corporation.vue?vue&type=script&lang=js"
export * from "./Corporation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports